module.exports = __webpack_public_path__ + "assets/vehicle-white.60a1f1c6.svg";